export default __webpack_public_path__ + "static/media/docs-illustration-min.bbc6f720.jpeg";